import React, { useState } from 'react';
import {
  Typography,
  Avatar,
  Badge,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  makeStyles,
  Tooltip

} from '@material-ui/core';
import theme from '../../theme';
import {
  CheckCircleOutline,
  CloseOutlined,
  RestoreOutlined
} from '@material-ui/icons';
import CommonInput from '../input';
import CommonButton from '../button';

const useStyles = makeStyles((th) => ({
  root: {
    padding: th.spacing(1.5),
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.colors.DodgerBlue,
    },
    overflowY: "scroll"
  },
  active: {
    backgroundColor: theme.colors.DodgerBlue,
    color: theme.colors.White
  },
  name: {
    fontWeight: 600,
    fontSize: '1rem'
  },
  message: {
    color: th.palette.text.secondary,
    fontSize: '0.85rem'
  },
  timestamp: {
    fontSize: '0.75rem',
    color: th.palette.text.disabled,
  },
  close: {
    color: th.palette.error.light,
    "&:hover": {
      cursor: "pointer"
    }
  },
  check: {
    "&:hover": {
      cursor: "pointer"
    },
    color: theme.colors.MintGreen
  },
  process: {
    "&:hover": {
      cursor: "pointer"
    },
    "&:hover::after": {
      content: '"Process"',
      backgroundColor: theme.colors.Black,
      color: "#fff",
      padding: "4px 8px",
      borderRadius: "4px",
      position: "absolute",
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)",
      whiteSpace: "nowrap",
      zIndex: 10,

    },
    color: theme.colors.DodgerBlueLight
  },
  markerGrp: {
    display: "flex",
    flexDirection: "row",
    // flexWrap: "nowrap"
  },
  withMarker: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap"
  },

}));

const ChatTabItem = ({
  name,
  avatar,
  message,
  time,
  unread = false,
  active = false,
  onClick,
  chatIdentifier,
  allowMarker = true,
  checkAction,
  closeAction,
  responseAction,
  processingAction
}) => {
  const classes = useStyles();
  const [showMarkers, setShowMarkers] = useState(false)
  const [showInputResponse, setShowInputResponse] = useState(false)
  const [response, setResponse] = useState("")
  return (
    <>
      <ListItem
        onClick={() => {
          setShowMarkers(s => !s)
          onClick(chatIdentifier);
        }}
        className={`${classes.root} ${active ? classes.active : ''}`}
        alignItems="flex-start"
      >
        <ListItemAvatar>
          <Badge
            color="secondary"
            variant="dot"
            invisible={!unread}
            overlap="circular"
          >
            <Avatar src={avatar} alt={name} />
          </Badge>
        </ListItemAvatar>

        <ListItem>
          <ListItemText
            primary={
              <Typography className={classes.name}>{name}</Typography>
            }
            secondary={
              <Typography noWrap={!showMarkers} className={classes.message}>
                {message}
              </Typography>
            }
          />
        </ListItem>

        <ListItemSecondaryAction>
          <Typography className={classes.timestamp}>{time}</Typography>
        </ListItemSecondaryAction>

      </ListItem>
      {
        allowMarker && showMarkers ? (
          <div className={classes.markerGrp}>
            {
              checkAction ? (
                <CheckCircleOutline
                  onClick={checkAction?.bind(chatIdentifier)}
                  className={classes.check} />

              ) : null
            }
            {
              processingAction ? (
                <Tooltip title="Process" arrow>
                  <RestoreOutlined
                    className={classes.process}
                    onClick={() => {
                      processingAction(chatIdentifier, "processing")
                    }}
                  />
                </Tooltip>
              ) : null
            }
            {
              (closeAction || responseAction) ? (
                <Tooltip title="Close" arrow>
                  <CloseOutlined
                    onClick={() => {
                      setShowInputResponse(s => !s)
                      closeAction?.bind(chatIdentifier)
                    }}
                    className={classes.close}
                  />
                </Tooltip>
              ) : null
            }

          </div>
        ) : null
      }
      {
        (showInputResponse && allowMarker) && (
          <>
            <CommonInput
              placeholder={"Enter A FeedbackResponse"}
              min={2}
              value={response}
              onChange={(e) => {
                setResponse(e.target.value)
              }}
              error={
                (
                  (
                    response.length <= 0
                  )
                )
              }
              helperText={response.length <= 0 &&
                "Your response should not be empty"}
            />
            <CommonButton
              type="button"
              disabled={response.length <= 2}
              onClick={(e) => {
                responseAction(chatIdentifier, response)
                setResponse("")
              }}
              text="Submit"
              stylevariant="primary"
            />
          </>)

      }
    </>
  );
};

export default ChatTabItem;
